import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/nin/v1/page.tsx");
